import React, { Component } from 'react';
import { findFlagUrlByIso3Code } from "country-flags-svg";
import flagEU  from './../../../assets/images/icons/eu.svg';
import PropTypes from 'prop-types';

class FlagsList extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            id: ''
        }
    }
   
    render() {
    let flagUrl = '';
    if (this.props.iso !== 'Європейський Союз') {
        flagUrl = findFlagUrlByIso3Code(this.props.iso)
    } else {
        flagUrl = flagEU;
    }
        return (
        <a href='#' className="state-logo" rel="noreferrer" id={`#${this.props.direction}${this.props.id}`}
             onClick={(e) => {this.props.scrollToTariff(e)}}>
            <img src={flagUrl} alt={'flag'} referrerPolicy="no-referrer"/>
            <span>{this.props.countryName}</span>
        </a>
        )
    }
}

export default FlagsList;

FlagsList.propTypes = {
    iso: PropTypes.string.isRequired,
    countryName: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
    scrollToTariff: PropTypes.func
}